/* global css */
import React, {
  useState, useEffect, useRef,
} from 'react';
import { cssInJS } from '../../utils/styles';
import THEME from '../../shared/theme';

interface Props {
  disabled: boolean,
  value: { textValue: string },
  onChange(newValue: any): void,
}

/**
 * @deprecated this file has been replaced by material
 */
const DateField: React.FC<Props> = ({
  disabled,
  value,
  onChange,
}: Props) => {
  const [textValue, setTextValue] = useState<string>(value.textValue || '');
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleInput = (event: React.FormEvent<HTMLInputElement>): void => {
    if (disabled) {
      return;
    }

    const inputValue = event.currentTarget.value;
    setTextValue(inputValue);
  };

  useEffect(() => {
    const input = inputRef.current;

    if (!input) {
      return undefined;
    }

    const handleNativeChange = (event: Event) => {
      if (disabled) {
        return;
      }

      const inputValue = (event.target as HTMLInputElement).value;
      setTextValue(inputValue);

      const newValue = value;
      newValue.textValue = inputValue;
      onChange(newValue);
    };

    input.addEventListener('change', handleNativeChange);
    return () => {
      input.removeEventListener('change', handleNativeChange);
    };
  }, [disabled, onChange, value]);

  useEffect(() => {
    setTextValue(value.textValue || '');
  }, [value.textValue]);

  return (
    <input
      ref={inputRef}
      type="date"
      value={textValue}
      disabled={disabled}
      onInput={handleInput}
      // @ts-ignore
      className={css(styles.input)}
    />
  );
};

const styles = cssInJS({
  input: {
    marginTop: 4,
    border: '1px solid #d9d9d9',
    padding: '2px 4px',
    width: '100%',
    borderRadius: 5,
    fontSize: THEME.editFontSize,
    fontFamily: THEME.fontFamily,
  },
});

export default DateField;
